<template>
  <div>
    <v-divider />
    <v-row class="d-flex justify-sm-end">
      <v-col cols="12" sm="6" lg="3">
        <v-btn
          color="primary"
          outlined
          :to="`/manage/forms/${moderatedOperation.object_type}/${moderatedOperation.form_name}/${moderatedOperation.id}`"
          >{{ $t("button.see.originalForm") }}</v-btn
        >
      </v-col>
      <v-col cols="12" sm="6" lg="3">
        <v-btn
          color="purple"
          outlined
          v-if="moderatedOperation.object_id"
          :to="`/manage/edit/researchers/edit/${moderatedOperation.object_id}`"
          >{{ $t("button.see.editObject") }}</v-btn
        >
      </v-col>
      <v-spacer />
      <v-col cols="6" sm="3" md="2" class="d-flex justify-center">
        <FinishFormSwitch :item="moderatedOperation" />
      </v-col>
      <v-col cols="6" sm="3" md="3" lg="2">
        <ProcessingCommentDialog :moderated-operation="moderatedOperation" />
      </v-col>
    </v-row>
    <v-card class="pa-2" min-height="200">
      <v-overlay absolute :opacity="0" :value="moderatedOperation.data === undefined">
        <v-progress-circular indeterminate size="64" color="primary" />
      </v-overlay>
      <AssignSimpleRelationField
        :state="moderatedOperation.state"
        field="category"
        :data-mod-op="moderatedOperation.data"
        v-if="moderatedOperation.data !== undefined"
        :items-fromdb="categories"
        items-fromdb-text="internal_name"
      />

      <div v-if="moderatedOperation.data !== undefined && moderatedOperation.data.user.extend_workplace_assignation_date">
        <h5 class="text-left">
          {{ $t("form.workplace.name") }}
        </h5>
        <v-row>
          <v-col cols="12" md="8">
            <v-alert dense text type="warning">
              {{$t('form.info.not_extend_automatic')}}
            </v-alert>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <v-divider />
    <ProcessFormActions :item="moderatedOperation" />
  </div>
</template>

<script>
import ProcessFormActions from "../../action_buttons/ProcessFormActions";
import AssignSimpleRelationField from "../../reusables/AssignSimpleRelationField";
import axios from "axios";
import ProcessingCommentDialog from "../../reusables/ProcessingCommentDialog";
import FinishFormSwitch from "../../reusables/FinishFormSwitch";
import investigator_model from "../../../mixins/model_utils/investigator_model";
export default {
  name: "ProcessNewVinculation",
  mixins: [investigator_model],
  components: {
    FinishFormSwitch,
    ProcessingCommentDialog,
    ProcessFormActions,
    AssignSimpleRelationField
  },

  data: () => ({
    moderatedOperation: {},
    persons: []
  }),

  created() {
    this.getCategories();
    this.getData();
  },
  methods: {
    getData() {
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/review/investigator/" +
        this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.moderatedOperation = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped></style>
